module.exports = __webpack_public_path__ + "static/img/0000志愿者.db3d233.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000志愿者.jpg
// module id = B2/u
// module chunks = 0